import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import { useState, useRef, useEffect } from 'react';
import { getClosestLanguageCode } from 'i18n/options';
import { extractTextFromPdf } from './extractTextFromPdf';
import api from 'utils/api';
import config from 'utils/config';
import { FILE_FORMATS } from 'utils/asset/constants';
import getAssetType from 'utils/asset/getAssetType';
export function useAiSuggestions() {
  var _useState = useState({
      description: {
        status: 'none'
      },
      locale: {
        status: 'none'
      }
    }),
    _useState2 = _slicedToArray(_useState, 2),
    aiSuggestions = _useState2[0],
    setAiSuggestions = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    resourceForAsyncAnalysis = _useState4[0],
    setResourceForAsyncAnalysis = _useState4[1];
  var isAnalysisInProgressRef = useRef(false);
  useEffect(function () {
    var _getAssetType;
    if (config.assetEditorAutoSuggestions && resourceForAsyncAnalysis && isAnalysisInProgressRef.current === false && (resourceForAsyncAnalysis instanceof URL || ((_getAssetType = getAssetType(resourceForAsyncAnalysis)) === null || _getAssetType === void 0 ? void 0 : _getAssetType.fileFormat) === FILE_FORMATS.PDF)) {
      var extractSummary = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var postBody, _yield$api, contentError, chatGptDescription, detectedLanguageCode, detectedLocale;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                isAnalysisInProgressRef.current = true;
                setAiSuggestions(function (prev) {
                  return _objectSpread(_objectSpread({}, prev), {}, {
                    description: {
                      status: 'pending'
                    }
                  });
                });

                /**
                 * TODO: Split out individual API calls to individual calls to avoid the current
                 * request waterfall & use React Query for de-duplication and caching
                 */
                _context.prev = 2;
                // extract text from pdf
                postBody = {};
                if (!(resourceForAsyncAnalysis instanceof URL)) {
                  _context.next = 8;
                  break;
                }
                postBody.url = resourceForAsyncAnalysis.toString();
                _context.next = 11;
                break;
              case 8:
                _context.next = 10;
                return extractTextFromPdf(resourceForAsyncAnalysis);
              case 10:
                postBody.text = _context.sent;
              case 11:
                _context.next = 13;
                return api('post', '/api/ai/summarise', null, postBody);
              case 13:
                _yield$api = _context.sent;
                contentError = _yield$api.error;
                chatGptDescription = _yield$api.summary;
                detectedLanguageCode = _yield$api.langCode;
                detectedLocale = getClosestLanguageCode(detectedLanguageCode);
                setAiSuggestions({
                  locale: detectedLocale ? {
                    status: 'ready',
                    value: detectedLocale
                  } : {
                    status: 'none'
                  },
                  description: {
                    status: contentError ? 'error' : 'ready',
                    value: chatGptDescription
                  }
                });
                setResourceForAsyncAnalysis(null);
                isAnalysisInProgressRef.current = false;
                _context.next = 26;
                break;
              case 23:
                _context.prev = 23;
                _context.t0 = _context["catch"](2);
                setAiSuggestions(function (prev) {
                  return _objectSpread(_objectSpread({}, prev), {}, {
                    description: {
                      status: 'error'
                    }
                  });
                });
              case 26:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[2, 23]]);
        }));
        return function extractSummary() {
          return _ref.apply(this, arguments);
        };
      }();
      extractSummary();
    }
  }, [resourceForAsyncAnalysis]);
  return {
    aiSuggestions: aiSuggestions,
    analyseResource: setResourceForAsyncAnalysis
  };
}